import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD5V2K-H1pQTtHaEpdageKZqGEbE8BLaT8",
  authDomain: "meihua-16427.firebaseapp.com",
  projectId: "meihua-16427",
  storageBucket: "meihua-16427.firebasestorage.app",
  messagingSenderId: "464767765598",
  appId: "1:464767765598:web:72bf3301b41d0017cfb8cf"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * 本地联调用 Firebase 模拟器 —— 只在 VITE_USE_EMULATOR=1 时启用。
 * 不设置这个变量时连线上环境，行为与线上一致。
 */
const useEmulator = String((import.meta as any).env?.VITE_USE_EMULATOR ?? '') === '1';

if (useEmulator) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8081);
  console.info('[MeiHua] 已连接 Firebase 模拟器（auth:9099 / firestore:8081）');
}
